import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { permissionGrantProjectsLimitsResource } from '@jira/router-resources__admin-pages-performance/src/permissionGrantProjectsLimitsResource.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformancePermissionGrantProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformancePermissionGrantProjectLimitRoute.tsx';
import { permissionGrantProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/permission-grant/project-limit/PermissionGrantProjectLimitEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

const getPermissionGrantProjectLimitResources = () =>
	fg('slt1-1397_site_optimizer_permission_grant_metric')
		? [
				...getNavigationResources(),
				navigationSidebarGlobalResource,
				permissionGrantProjectsLimitsResource,
			]
		: [...getNavigationResources(), navigationSidebarGlobalResource];

export const globalSettingsPerformancePermissionGrantProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformancePermissionGrantProjectLimitRoute,
	() => ({
		group: 'global-settings',

		canTransitionIn: () => fg('slt1-1397_site_optimizer_permission_grant_metric'),

		entryPoint() {
			if (!fg('slt1-1397_site_optimizer_permission_grant_metric')) {
				return notFoundPageEntrypoint;
			}
			return permissionGrantProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: getPermissionGrantProjectLimitResources(),

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
